<template>

  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          page-title="Proceso Acreditación"
          directory=""
          :icon="'trello'"
        />
      </div>

      <div class="col-sm-12 col-md-6">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            @click="
              () => {
                $hub.$emit('reload-table');
              }
            "
          >
            <i data-feather="refresh-ccw" class="pr-2" /> Refrescar
          </button>
        </div>
      </div>

      <div class="col-md-12">
        <app-tab :tabs="tabsHorizontal" type="horizontal" />
      </div>
    </div>
  </div>
</template>


<script>
// import CopyButton from "CopyButton";

export default {
  name: "Tabs",
//   components: { CopyButton },
  data() {
    return {
      icon: "settings",
      tabsHorizontal: [
        {
          icon: "activity",
          name: "Asignar Gestor Técnico de Expediente",
          component: "tab-asign",
          permission: "",
        },
        
        {
          icon: "inbox",
          name: "Registro de Ingreso de solicitud de acreditación y acuse recibo ",
          component: "tab-acusse-receipt",
          permission: "",
        },

        //{
          //icon: "check-square",
          //name: "Registro de Ingreso de solicitud de acreditación y acuse recibo",
          //component: "tab-review",
          //permission: "",
        //},

        {
          icon: "trello",
          name: "Pendiente Desarrollo Esquema",
          component: "tab-sendrevision",
          permission: "",
        },
        {
          icon: "paperclip",
          name: "Pendiente Busqueda Experto",
          component: "tab-sendrevision",
          permission: "",
        },
        
      ],
      
    };
  },
};
</script>
